module.exports = __webpack_public_path__ + "static/img/1.845847dd.png";